//导航目录列表
import { useStore } from "@/store";
import urlConfig from "@/services/urlConfig";

function getMenuList() {
    let dataAnalysisItem:any =  {
        title: '数据分析',
        path: '/dataAnalysis',
        icon: 'icon-ic_board_normalbeifen',
        alwaysShow: true,
        role: ['0', '1', '2', '3', '4'],
        children: [
            {
                title: '数据看板',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: 'panelData',
            },
            {
                title: '看板管理',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: '/dataAnalysis/panelManage/manageList',
            },
            {
                title: '指标管理',
                alwaysShow: true ,
                role: ['0', '1', '2', '3', '4'],
                path: 'indicatorManage',
            },
            {
                title: '事件管理',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: 'dataManage',
            }

        ]
    };

    let attenceAnalysisItem:any = {
        title: '考勤分析',
        path: '/attenceAnalysis',
        icon: 'icon-ic_board_normalbeifen',
        alwaysShow: true,
        role: ['0', '1', '2', '3', '4'],
        children: [
            {
                title: '考勤列表',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: '/attenceAnalysis/attenceLists'
            },
            {
                title: '考勤数据推送',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: '/attenceAnalysis/pushSettings' 
            },
        ]
    };

    let liveClassroomItem:any = {
        title: '线上课程督导巡课',
        path: '/liveClassroom',
        icon: 'icon-a-beifen2',
        alwaysShow: true,
        role: ['0', '1', '2', '3', '4'],
        children: [
            {
                title: '实时课堂教学监控',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: '/liveClassroom/teaching'
            },
            {
                title: '课表清单',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: '/liveClassroom/classroomStatistics/statisticsCourseList' 
            },
            {
                title: '历史直录播课堂',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: '/liveClassroom/historyClassroom/videoList'
            },
            {
                title: '加课码巡课',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: '/liveClassroom/joinCodeSupervise/joinCode'
            }
        ]
    };

    let classRoomInspectionItem:any = {
        title: '线下（教室）督导巡课',
        path: 'http://10.9.22.6',
        icon: 'icon-wangluoxunke',
        alwaysShow: true,
        role: ['0', '1', '2', '3', '4'],
    };

    let recordClassroomItem:any = {
        title: '录播教室',
        path: '/recordedBroadcastClassroom',
        icon: 'icon-live',
        alwaysShow: true,
        role: ['0'],
    };

    let academicAffairsItem:any =         {
        title: '教务数据管理',
        path: '/academicAffairs',
        icon: 'icon-a-bianzu7',
        alwaysShow: true,
        role: ['0', '1', '2', '3', '4'],
        children: [
            {
                title: '教务数据导入',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/academicAffairs/importDataEduc'
            },
            {
                title: '院系管理',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/academicAffairs/facultyManageEduc'
            },
            {
                title: '行政班管理',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/academicAffairs/administrativeEduc/administrativeList',
            },
            {
                title: '老师管理',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/academicAffairs/teacherManageEduc/teacherManageList'
            },
            {
                title: '学生管理',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/academicAffairs/studentManageEduc/studentManageList'
            },
            {
                title: '课程管理',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: 'courseManageEduc/courseListEduc'
            },
            {
                title: '学期管理',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/academicAffairs/semesterManageEduc'
            }
        ]
    };

    let onlineDtaManagementItem:any = {
        title: '线上数据管理',
        path: '/onlineDtaManagement',
        icon: 'icon-a-bianzu9',
        alwaysShow: true,
        role: ['0', '1', '2', '3', '4'],
        children: [
            {
                title: '线上用户',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/onlineDtaManagement/onlineDataUser'
            },
            {
                title: '线上课堂',
                alwaysShow: true,
                role: ['0', '1', '2', '3', '4'],
                path: '/onlineDtaManagement/onlineDataClass'
            },
        ]
    };

    let teachingResearchItem:any = {
        title: '虚拟教研室管理',
        path: '/teachingResearch/index',
        icon: 'icon-ic_resources_normalbeifen',
        alwaysShow: true,
        role: ['0'],
    };

    let resourceLibraryItem:any = {
        title: '资源库管理',
        path: '/resource/resourceLibrary',
        icon: 'icon-ic_resources_normalbeifen',
        alwaysShow: true,
        role: ['0'],
    };

    let moocPreviewsItem:any =         {
        title: '慕课数据汇总',
        path: '/moocPreviews',
        icon: 'icon-a-ic_data_selected2',
        alwaysShow: true,
        role: ['0', '1', '2', '3'],
        children: [
            {
                title: '数据概览',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/moocPreviews/moocPreview'
            },
            {
                title: '课程管理',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/moocPreviews/administration/courseManage'
            },
            {
                title: '高级筛选设置',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/moocPreviews/moocSet'
            },


        ]
    };

    let computerItem:any =         {
        title: '门户管理',
        path: '/computer',
        icon: 'icon-a-bianzu5',
        alwaysShow: true,
        role: ['0', '1', '2', '3'],
        children: [
            {
                title: '门户建设',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/computer/construction/pageList'
            },
            {
                title: '素材管理',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/computer/material/essayManage'
            }
        ]
    };

    let educNotificationItem:any = {
        title: '通知与评教',
        path: '/educNotification',
        icon: 'icon-guanli',
        alwaysShow: true,
        role: ['0', '1', '2', '3'],
        children: [
            {
                title: '教务通知',
                path: '/educNotification/notification/notificationList',
                // icon: 'icon-a-ic_notice_normalbeifen4',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
            },
            {
                title: '学生评教',
                path: '/studentEvaluation/studentEvaluationList',
                // icon: 'icon-chengyuan',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
            },
        ]
    };

    let subClassAdministrationItem:any = {
        title: '楼栋教室管理',
        path: '/classAdministration',
        alwaysShow: true,
        role: ['0'],
        children: [
            {
                title: '校区管理',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/classAdministration/campusData'
            },
            {
                title: '楼栋管理',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/classAdministration/buildingData'
            },
            {
                title: '教室管理',
                alwaysShow: true,
                role: ['0', '1', '2', '3'],
                path: '/classAdministration/classroomData'
            }
        ]
    };

    let subStorageFeeItem:any = {
        title: '空间存储',
        path: '/storage/storageFee',
        alwaysShow: true,
        role: ['0'],
    };

    let subValueAddedServicesItem:any = {
        title: '增值服务',
        path: '/vipManagement/valueAddedServices',

        alwaysShow: true,
        role: ['0'],
    };

    let subAuthorityManagementListItem:any = {
        title: '权限管理',
        path: '/authorityManagement/authorityManagementList',
       
        alwaysShow: true,
        role: ['0', '1', '3'],
    };

    let subVipAccountManageListItem:any = {
        title: 'VIP管理',
        path: '/vipManagement/vipAccountManageList',
        alwaysShow: true,
        role: ['0'],
    };

    let subSystemJournalListItem:any = {
        title: '操作日志',
        path: '/systemJournal/systemJournalList',
        alwaysShow: true,
        role: ['0', '1', '2', '3', '4'],
    };

    let authorityManagementItem:any = {};

    if(urlConfig.privateDeploy){
        authorityManagementItem = {
            title: '系统管理',
            path: '/authorityManagement',
            icon: 'icon-set',
            alwaysShow: true,
            role: ['0', '1', '2', '3','4'],
            children: [
                subClassAdministrationItem,
                subAuthorityManagementListItem,
                subSystemJournalListItem,
            ]
        };
    }else{
        authorityManagementItem = {
            title: '系统管理',
            path: '/authorityManagement',
            icon: 'icon-set',
            alwaysShow: true,
            role: ['0', '1', '2', '3','4'],
            children: [
                subClassAdministrationItem,
                subStorageFeeItem,
                subValueAddedServicesItem,
                subAuthorityManagementListItem,
                subVipAccountManageListItem,
                subSystemJournalListItem,
            ]
        };
    }

    let MenuList: object[] = [];
    if(urlConfig.privateDeploy){
        MenuList = [
            dataAnalysisItem,
            attenceAnalysisItem,
            liveClassroomItem,
            academicAffairsItem,
            onlineDtaManagementItem,
            teachingResearchItem,
            resourceLibraryItem,
            computerItem,
            educNotificationItem,
            authorityManagementItem,
        ];
    }else{
        MenuList = [
            dataAnalysisItem,
            attenceAnalysisItem,
            classRoomInspectionItem,
            liveClassroomItem,
            recordClassroomItem,
            academicAffairsItem,
            onlineDtaManagementItem,
            teachingResearchItem,
            resourceLibraryItem,
            moocPreviewsItem,
            computerItem,
            educNotificationItem,
            authorityManagementItem,
        ];
    }
    return  MenuList;   
}


export const MenuList = getMenuList();